import { Bookmark, Pencil, Plus, RefreshCw, Trash2 } from "lucide-react";
import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";

import { api } from "@/api";

export const RecycleTemplates = ({ current, onApply }) => {
  const [items, setItems] = useState([]);
  const [activeId, setActiveId] = useState(null);
  const load = useCallback(() => api.get("/recycle/templates").then(({ data }) => setItems(data)).catch(() => {}), []);
  useEffect(() => { load(); }, [load]);

  const safe = (fn) => async (...args) => { try { await fn(...args); } catch { toast.error("Action impossible sur le modèle, réessayez."); } };
  const save = safe(async () => {
    const name = window.prompt("Nom du modèle (ex. Maisons Occitanie)");
    if (!name?.trim()) return;
    const { data } = await api.post("/recycle/templates", { name, ...current() });
    setActiveId(data.id); toast.success(`Modèle « ${data.name} » enregistré`); load();
  });
  const update = safe(async (t) => {
    await api.put(`/recycle/templates/${t.id}`, { name: t.name, ...current() });
    toast.success(`Modèle « ${t.name} » mis à jour avec les réglages actuels`); load();
  });
  const rename = safe(async (t) => {
    const name = window.prompt("Nouveau nom", t.name);
    if (!name?.trim()) return;
    await api.put(`/recycle/templates/${t.id}`, { ...t, name }); load();
  });
  const remove = safe(async (t) => {
    if (!window.confirm(`Supprimer le modèle « ${t.name} » ?`)) return;
    await api.delete(`/recycle/templates/${t.id}`); if (activeId === t.id) setActiveId(null); load();
  });

  return (
    <div className="rc-templates" data-testid="recycle-templates">
      <Bookmark size={16} /><strong>Modèles</strong>
      {items.length === 0 && <small>Aucun modèle : réglez vos filtres puis enregistrez-les.</small>}
      {items.map((t) => (
        <span key={t.id} className={`rc-tpl${activeId === t.id ? " on" : ""}`} data-testid={`recycle-tpl-${t.id}`}>
          <button type="button" className="rc-tpl-name" onClick={() => { setActiveId(t.id); onApply(t); }} data-testid={`recycle-tpl-apply-${t.id}`}>{t.name}</button>
          {activeId === t.id && <button type="button" title="Mettre à jour avec les réglages actuels" onClick={() => update(t)} data-testid={`recycle-tpl-update-${t.id}`}><RefreshCw size={12} /></button>}
          <button type="button" title="Renommer" onClick={() => rename(t)} data-testid={`recycle-tpl-rename-${t.id}`}><Pencil size={12} /></button>
          <button type="button" title="Supprimer" onClick={() => remove(t)} data-testid={`recycle-tpl-delete-${t.id}`}><Trash2 size={12} /></button>
        </span>
      ))}
      <button type="button" className="secondary-button" onClick={save} data-testid="recycle-tpl-save"><Plus size={14} /> Enregistrer comme modèle</button>
    </div>
  );
};
